import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
    interface Window {
        _mfq: any
        dataLayer: any
    }
}

interface tracklead {
    email: string
    phone: string
}

function gtag(...args: any) {
    window.dataLayer.push(arguments)
    console.log('DATA LAYER: ', window.dataLayer)
}

const build_tracking = (script_url: string) => {
    var s = document.getElementsByTagName('script')[0]
    var b = document.createElement('script')
    b.type = 'text/javascript'
    b.async = true
    b.src = script_url
    s.parentNode?.insertBefore(b, s)
}

export const HandleTracking = () => {
    let location = useLocation()

    useEffect(() => {
        trackInitialization(location)
    }, [])

    useEffect(() => {
        trackPageViews(location.pathname)
    }, [location])
}

export const trackInitialization = (location: any) => {
    console.log('TRACKING......', process.env.REACT_APP_LEAD_SOURCE)
    window._mfq = window._mfq || []
    window.dataLayer = window.dataLayer || []

    // Add tracking initialization based on lead source
    gatherUTMS(location)
}

export const trackPageViews = (pathname: any) => {
    // Add page view tracking based on lead source
    console.log('Page view:', pathname)
}

export const trackLead = ({ email, phone }: tracklead) => {
    console.log('Track lead:', { email, phone })
    // Add lead tracking based on lead source
}

export const trackSubmitApplication = () => {
    console.log('Track submit application')
    // Add submit application tracking
}

export const trackCompleteRegistration = () => {
    console.log('Track complete registration')
    // Add complete registration tracking
}

const gatherUTMS = (location: any) => {
    let paramsObj: any = {}
    location.search
        .replace('?', '')
        .split('&')
        .forEach((item: string) => {
            let arr = item.split('=')
            paramsObj[arr[0]] = arr[1]
        })
    const paramString = JSON.stringify(paramsObj)
    if (!localStorage.getItem('utms') || paramString !== '{}') localStorage.setItem('utms', paramString)
}
